import styled, { injectGlobal } from 'styled-components';
import bgPattern from '../images/bg-pattern.png';
import { IS_APP } from '../../services/target';

injectGlobal`
  #main.clean {
    padding-top: 60px;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: cover;
    height: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
  }

  .linkClean {
    margin-top: 12px !important;
    display: inline-block;
  }
  ${IS_APP &&
    `
    .__begamer{
      background-image: none !important;
    }
  `}

  .__bebanca{
    &._target-app{
      padding-top: 0px !important;
      #_content-box #_box{
        padding-top: 0;
        h1{
          margin-top: 0px;
        }
        > div{
          margin-top: -5px;
        }
      }
    }

    &:before, &:after{
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
    }
    &:before{
      background-color: ${IS_APP ? '#fff' : '#ffbc3a'};
    }
    &:after{
    ${!IS_APP && `background-image: url(${bgPattern})`};
      opacity: 0.08;
    }

    input.btn, a.btn, button.btn{
      background-color: #ffbc3a;
    }

    input.btn:hover, a.btn:hover, button.btn:hover{
      background-color: #f9c45d;
    }

    a{
      border-bottom: 1px solid #ffbc3a;
    }

    a:hover{
      color: #ffbc3a;
    }
  }
`;

export const Footer = styled.p`
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin-top: 60px;
`;



// WEBPACK FOOTER //
// ./src/assets/styles/clean.js